import "./styles.modules.scss";

import React, { useState, Fragment } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsTrash as TrashIco } from "react-icons/bs";
import { MdInfo } from "react-icons/md";

const AlternativeCard = ({ item, index, model, trashEvent }) => {
  const keyText = model === "scales" ? "title" : "description";
  const [cont, setCont] = useState(item[keyText]?.length || 0);
  const [valueLocal, setValueLocal] = useState(
    typeof item.value === "number" ? item.value : 0
  );

  const handleChangeValue = (e) => {
    const raw = parseInt(e.currentTarget.value, 10);
    // const clamped = Number.isNaN(raw) ? 0 : Math.max(0, Math.min(5, raw));
    item.value = raw;
    setValueLocal(raw);
  };

  if (model === "scales") {
    return (
      <div className="altIt">
        <div
          className="altItSelec altItSelecItemCustom"
          style={{
            display: "grid",
            gridTemplateColumns: "70px 1fr",
            columnGap: 12,
            alignItems: "start",
          }}
        >
          <div style={{ width: 70 }}>
            <div
              className="contador"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                color: "#6c757d",
                textAlign: "left",
                marginTop: 4,
              }}
            >
              <OverlayTrigger
                trigger={["hover", "focus", "click"]}
                placement="top"
                rootClose
                overlay={
                  <Tooltip id={`tt-valor-${index}`}>
                    Atribua um valor numérico para cada opção; ele representa o peso da resposta no
                    cálculo da média/pontuação. Ex.: 1 = Péssimo, 5 = Excelente.
                  </Tooltip>
                }
              >
                <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                  <MdInfo size={16} color="#000" />
                  <span>Valor *</span>
                </span>
              </OverlayTrigger>
            </div>

            <Form.Control
              type="number"
              // min={0}
              // max={5}
              step={1}
              value={valueLocal}
              onChange={handleChangeValue}
              style={{ textAlign: "center", color: valueLocal === 0 ? "#B0B0B0" : "#000000" }}
            />

            <div
              className="contador"
              style={{ visibility: "hidden", marginTop: 4, textAlign: "right" }}
              aria-hidden="true"
            >
              <span>00</span>/45
            </div>
          </div>

          <div style={{ width: "100%" }}>
            <div
              className="contador"
              style={{ textAlign: "right", marginTop: 4, color: "#6c757d" }}
            >
              <span>Coluna</span>
            </div>
            <Form.Control
              as="textarea"
              rows={1}
              defaultValue={item.title}
              maxLength={45}
              onChange={(e) => {
                item.title = e.currentTarget.value;
                setCont(e.currentTarget.value.length);
              }}
              placeholder={`Coluna ${index + 1}`}
            />
            <div className="contador" style={{ textAlign: "right", marginTop: 4 }}>
              <span>{cont}</span>/45
            </div>
          </div>
        </div>

        <div className="altRemove">
          <p>Remover</p>
          <button onClick={() => trashEvent(index, model)}>
            <TrashIco />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="altIt">
      <div className="altItSelec altItSelecItemCustom">
        <div style={{ width: "100%", marginTop: 4, color: "#6c757d", textAlign: "left" }}>
          <span>Linha</span>
        </div>
        <Form.Control
          as="textarea"
          rows={1}
          maxlength="90"
          defaultValue={item[model === "scales" ? "title" : "description"]}
          onChange={(e) => {
            item.description = e.currentTarget.value;
            setCont(e.currentTarget.value.length);
          }}
          placeholder={`Linha ${index + 1}`}
        />
        <div className="contador">
          <span>{cont}</span>/90
        </div>
      </div>

      <div className="altRemove">
        <p>Remover</p>
        <button onClick={() => trashEvent(index, model)}>
          <TrashIco />
        </button>
      </div>
    </div>
  );
};

const MultiLikertScale = ({
  questionScales,
  setQuestionScales,
  questionOptions,
  setQuestionOptions,
}) => {
  const addAlt = (model) => {
    if (model === "scales") {
      setQuestionScales((item) => [...item, { title: "", value: 0 }]);
    } else {
      setQuestionOptions((item) => [...item, { description: "", isCorrect: true }]);
    }
  };

  const trashEvent = (index, model) => {
    if (model === "scales") {
      const newquestionScale = [...questionScales];
      newquestionScale.splice(index, 1);
      setQuestionScales(newquestionScale);
    } else {
      const newQuestionOptions = [...questionOptions];
      newQuestionOptions.splice(index, 1);
      setQuestionOptions(newQuestionOptions);
    }
  };

  return (
    <div className="form-group form-group-block-02">
      <div className="card">
        <div className="card-header template-card-header">Escala múltipla</div>
        <div className="card-body template-card-body d-flex flex-row">
          <div className="col-lg-7 col-md-7 col-sm-12 altContainer altContainerInit">
            <div className="altList">
              {questionOptions.length > 0 ? (
                questionOptions.map((item, index) => (
                  <Fragment key={index}>
                    <AlternativeCard
                      item={item}
                      index={index}
                      model="options"
                      trashEvent={trashEvent}
                    />
                  </Fragment>
                ))
              ) : (
                <div className="noAlternative">Sem nenhuma linha.</div>
              )}
            </div>

            <Button variant="warning" className="btnAdd" onClick={() => addAlt("options")}>
              Adicionar nova linha
            </Button>
          </div>

          <div className="col-lg-5 col-md-5 col-sm-12 altContainer">
            <div className="altList">
              {questionScales.length > 0 ? (
                questionScales.map((item, index) => (
                  <Fragment key={index}>
                    <AlternativeCard
                      item={item}
                      index={index}
                      model="scales"
                      trashEvent={trashEvent}
                    />
                  </Fragment>
                ))
              ) : (
                <div className="noAlternative">Sem nenhuma coluna.</div>
              )}
            </div>

            <Button variant="warning" className="btnAdd" onClick={() => addAlt("scales")}>
              Adicionar nova coluna
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiLikertScale;
